import { post } from '../Services/http';
import {
  LIBRARY_RECEIVE,
  LIBRARY_RECEIVE_CATEGORIES,
  LIBRARY_RECEIVE_DOCUMENT_TYPES,
  LIBRARY_FILTER,
  LIBRARY_SELECTED,
} from '../constants';

let abortController;

export const searchFiles = (
  fileTemplateType,
  query,
  category,
  documentType,
  pageNumber
) => (dispatch, getState) => {
  abortController && abortController.abort();
  abortController = new AbortController();
  return post(
    '/api/library/searchFiles',
    {
      fileTemplateType,
      query,
      category,
      documentType,
      pageNumber,
    },
    abortController
  )
    .then((response) => response.json())
    .then((result) => dispatch(receive(result, fileTemplateType)));
};

export const getZipFile = (fileIds) => (dispatch) => {
  abortController && abortController.abort();
  abortController = new AbortController();
  return post('/api/library/getZipFile', { fileIds }, abortController)
    .then((response) => response.blob())
    .then((blob) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `library_${Date.now()}.zip`;
      a.click();
      URL.revokeObjectURL(a.href);
    });
};

export const receiveCategories = (categories) => ({
  type: LIBRARY_RECEIVE_CATEGORIES,
  payload: {
    categories,
  },
});

export const receiveDocumentTypes = (documentTypes) => ({
  type: LIBRARY_RECEIVE_DOCUMENT_TYPES,
  payload: {
    documentTypes,
  },
});

export const receive = (result, fileTemplateType) => {
  if (fileTemplateType === 1)
    return {
      type: LIBRARY_RECEIVE,
      payload: {
        documents: result,
      },
    };
  if (fileTemplateType === 2)
    return {
      type: LIBRARY_RECEIVE,
      payload: {
        photos: result,
      },
    };
};

export const setQuery = (query) => ({
  type: LIBRARY_FILTER,
  payload: {
    query,
  },
});

export const setFileTemplateType = (fileTemplateType) => ({
  type: LIBRARY_FILTER,
  payload: {
    fileTemplateType,
  },
});

export const setCategory = (category) => ({
  type: LIBRARY_FILTER,
  payload: {
    category,
  },
});

export const setDocumentType = (documentType) => ({
  type: LIBRARY_FILTER,
  payload: {
    documentType,
  },
});

export const toggleSelect = (selected) => ({
  type: LIBRARY_SELECTED,
  payload: {
    selected,
  },
});

export const setPage = (pageNumber) => ({
  type: LIBRARY_FILTER,
  payload: {
    pageNumber,
  },
});

export const toggleZip = () => (dispatch, getState) => {
  dispatch(makeZip(!getState().library.zip));
};

const makeZip = (zip) => ({
  type: LIBRARY_FILTER,
  payload: {
    zip,
  },
});
